<template>
  <div>
    <section class="">
      <div class="level-item">
        <img src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" />
      </div>
      <div class="level-item">
        <p class="title is-2">Enquiry Form</p>
      </div>
      <br />
    </section>
    <section class="container section page-header section is-main-section">
      <p class="title is-4" style=" text-align: center;">Form saved successfully. Thank you !!</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ThankYouPage'
}
</script>
